module.exports = __webpack_public_path__ + "assets/images/946178c0887ff665c5fbb5144f8da63e.png";